import React, {useState} from 'react'
import './Navbar.scss'
import logo from '../../assets/logo-vc.png'
import crown from '../../assets/crown.png'
import {faUser,faTimes,faBars} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {Link} from 'react-router-dom'
import LoginForm from '../loginform/LoginForm'
import RegisterForm from '../registerform/RegisterForm'


const Navbar = () => {

    const [click, setClick] = useState(false)
    const [showLogin, setShowLogin] = useState(false)
    const [showRegister, setShowRegister] = useState(false)

    const handleClick = () => setClick(!click)
    const closeMobileMenu = () => setClick(false)

    const handleShowRegister = () => {
        setShowLogin(false)
        setShowRegister(true)
    }
    const handleShowLogin = () => {
        setShowLogin(true)
        setShowRegister(false)
    }

    return (
        <>
            <div className="navbar__container">
                <div className="navbar__container-wrap">

                    <div className="navbar-logo">
                        <img src={logo} alt="Logo"/>
                    </div>

                    <div className={click ? "navbar-click active" : "navbar-click"}>
                        <div className="navbar-link">
                            <ul>
                                <Link to="/" className="navbar-link-home"><li onClick={closeMobileMenu}>Home</li></Link>
                                <li onClick={closeMobileMenu}>About</li>
                                <li onClick={closeMobileMenu}>News</li>
                            </ul>
                        </div>

                        <div className="navbar-crown">
                            <img src={crown} alt="crown"/>
                            <h1>0</h1>
                        </div>

                        <div className="navbar-user" onClick={() => setShowLogin(true)}>
                            <FontAwesomeIcon icon={faUser} size='2x' className="navbar-user-icon"/>
                        </div>
                    </div>

                    <div className="navbar-menu-icon" onClick={handleClick}>
                        {click? <FontAwesomeIcon icon={faTimes} size='2x'/> : <FontAwesomeIcon icon={faBars} size='2x'/>}
                    </div>
                </div>
            </div>
            {showLogin && <LoginForm onClose={() => setShowLogin(false)} onRegister={handleShowRegister}/>}
            {showRegister && <RegisterForm onClose={() => setShowRegister(false)} onLogin={handleShowLogin}/>}
        </>
    )
}

export default Navbar
